import { render, staticRenderFns } from "./MobileTab.vue?vue&type=template&id=a4928c44&scoped=true"
import script from "./MobileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobileTab.vue?vue&type=style&index=0&id=a4928c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4928c44",
  null
  
)

export default component.exports